// extracted by mini-css-extract-plugin
module.exports = {"labels":"PieChart_labels__ingvr","label":"PieChart_label__TSdHo"};